import React from 'react';
import FacturasForm from './FacturasForm';

const NuevaFactura = () => {
    return <FacturasForm />;
};

export default NuevaFactura;
